import request from "../utils/request";
const spot = '/spot'
const free = '/free-spot'
// 返佣日排行
export function dailyApi(data) {
    return request({
        url: spot + `/invitation-activity/daily`,
        method: 'get',
        data,
    })
}

// 返佣总排行
export function totalApi(data) {
    return request({
        url: spot + `/invitation-activity/total`,
        method: 'get',
        data,
    })
}

// 返佣排行配置
export function rankConfig() {
  return request({
    url: spot + `/invitation-activity/config`,
    method: 'get'
  })
}
//获取用户剩余金额
export function getuseramount(data) {
  return request({
      url: spot + "/spot/balance",
      method: "GET",
      data
  })
}

// 自由区--用户是否创建过副本
export function checkMemo() {
    return request({
        url: free + `/v3/memo-query`,
        method: 'get'
    })
}

// 自由区--查询限制
export function checkLimitApi() {
    return request({
        url: free + `/v3/check-limit`,
        method: 'get'
    })
}

// 自由区--链下拉列表
export function chainListApi() {
    return request({
        url: free + `/v3/chain-list`,
        method: 'get'
    })
}

// 自由区--上币检验
export function checkCurrencyAddress(data) {
    return request({
        url: free + '/v3/check/overhead',
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

// 自由区--副本标题校验
export function checkMemoApi(data) {
    return request({
        url: free + '/v3/check-memo',
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

// 自由区--上币（上新币）
export function createApi(data) {
    return request({
        url: free + '/v3/create-memo',
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

// 自由区--上币（新增副本）
export function createMemo(data) {
    return request({
        url: free + '/v3/create-memo/exist',
        method: 'post',
        data,
        headers: { 'Content-Type': 'application/json; charset=UTF-8' },
    })
}

// 自由区--获取延期页面信息
export function memoInfoApi(data) {
    return request({
        url: `/free-spot/v3/memo/toPay`,
        method: 'get',
        data
    })
}

// 自由区--支付延期费用
export function payUpFee(data) {
    return request({
        url: `/free-spot/v3/memo/pay`,
        method: 'get',
        data
    })
}


// WEBPACK FOOTER //
// ./src/api/spot.js